module.exports = __webpack_public_path__ + "img/powered-by-stripe.5260e65d.svg";